import { Cookies } from 'react-cookie';
import {
    TREES_PAYMENT_MODAL_ENABLED,
    TREES_PAYMENT_COOKIE_PREFIX,
    TREES_PAYMENT_MODAL_MAXIMUM_DISPLAY,
    TREES_PAYMENT_MODAL_START_DATE,
    TREES_PAYMENT_MODAL_END_DATE,
    TREES_PAYMENT_MODAL_PERIOD_DURATION_DAYS
} from './constants';
import { nowTimestamp, timestampPlusDays, toMoment, toTimestamp } from '../../../utils/dateUtils';

export const canShowTreesPaymentModal = () => {
    if (!TREES_PAYMENT_MODAL_ENABLED) {
        return false;
    }

    const cookie = getCookie();
    const currentPeriod = getCurrentPeriod();
    const nbClose = (cookie && cookie.nbClose) || 0;
    const until = (cookie && cookie.until) || null;
    const lastPeriod = (cookie && cookie.period) || null;

    // Si on a changé de période, on peut réafficher la modale
    const isNewPeriod = lastPeriod === null || lastPeriod < currentPeriod;

    return (
        toMoment(nowTimestamp()).isAfter(TREES_PAYMENT_MODAL_START_DATE) &&
        toMoment(nowTimestamp()).isBefore(TREES_PAYMENT_MODAL_END_DATE) &&
        (isNewPeriod || nbClose < TREES_PAYMENT_MODAL_MAXIMUM_DISPLAY) &&
        (!until || toMoment(nowTimestamp()).isAfter(toMoment(until)))
    );
};

export const handleTreesPaymentCookie = () => {
    const cookie = getCookie();
    const currentPeriod = getCurrentPeriod();
    const nbClose = (cookie && cookie.nbClose) || 0;
    const until = (cookie && cookie.until) || null;
    const lastPeriod = (cookie && cookie.period) || null;
    const nextDay = timestampPlusDays(nowTimestamp(), 1);

    // Si on est dans une nouvelle période, on reset le compteur
    const isNewPeriod = lastPeriod === null || lastPeriod < currentPeriod;
    const effectiveNbClose = isNewPeriod ? 0 : nbClose;

    // Première fermeture de la période
    if (effectiveNbClose === 0) {
        const newUntil =
            TREES_PAYMENT_MODAL_MAXIMUM_DISPLAY > 1 ? nextDay : getEndOfCurrentPeriod();
        setCookie(1, newUntil, currentPeriod);
    }
    // Fermetures suivantes
    else if (effectiveNbClose > 0 && until) {
        if (effectiveNbClose + 1 < TREES_PAYMENT_MODAL_MAXIMUM_DISPLAY) {
            setCookie(effectiveNbClose + 1, nextDay, currentPeriod);
        }
        if (effectiveNbClose + 1 === TREES_PAYMENT_MODAL_MAXIMUM_DISPLAY) {
            setCookie(effectiveNbClose + 1, getEndOfCurrentPeriod(), currentPeriod);
        }
    }
};

// Calcule le numéro de période depuis la date de début
const getCurrentPeriod = () => {
    const now = toMoment(nowTimestamp());
    const start = TREES_PAYMENT_MODAL_START_DATE;
    const daysSinceStart = now.diff(start, 'days');
    return Math.floor(daysSinceStart / TREES_PAYMENT_MODAL_PERIOD_DURATION_DAYS);
};

// Calcule la fin de la période actuelle
const getEndOfCurrentPeriod = () => {
    const currentPeriod = getCurrentPeriod();
    const start = TREES_PAYMENT_MODAL_START_DATE;
    const endOfPeriod = start
        .clone()
        .add((currentPeriod + 1) * TREES_PAYMENT_MODAL_PERIOD_DURATION_DAYS, 'days');
    const campaignEnd = TREES_PAYMENT_MODAL_END_DATE;

    // Ne pas dépasser la fin de la campagne
    return toTimestamp(endOfPeriod.isBefore(campaignEnd) ? endOfPeriod : campaignEnd);
};

const setCookie = (nbClose, until, period) => {
    const cookies = new Cookies();
    const cookieValue = `nbClose=${nbClose}&until=${until}&period=${period}`;
    cookies.set(`${TREES_PAYMENT_COOKIE_PREFIX}`, cookieValue, {
        path: '/',
        expires: TREES_PAYMENT_MODAL_END_DATE.toDate(),
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'strict'
    });
};

const getCookie = () => {
    const cookies = new Cookies();
    const cookie = cookies.get(`${TREES_PAYMENT_COOKIE_PREFIX}`);
    if (!cookie) return null;
    const params = new URLSearchParams(cookie);
    return {
        nbClose: parseInt(params.get('nbClose'), 10) || 0,
        until: parseInt(params.get('until'), 10) || 0,
        period: parseInt(params.get('period'), 10) || null
    };
};



// WEBPACK FOOTER //
// ./src/services/modal/TreesPaymentModal/utils.js